import React from 'react';
import PropTypes from 'prop-types';

import {Box, StickyTooltip} from 'views/components';
import {Avatar} from 'views/module';

const ConnectionBadge = (props) => {
  const {
    connection,
    sx,
  } = props;

  const label = connection.displayName;
  const hasFullPersonName = Boolean(connection.firstName && connection.lastName);
  const hasConnectionRn = Boolean(connection.connectionRn);
  const initial = label.charAt(0).toUpperCase();

  if (hasFullPersonName && hasConnectionRn) {
    return (
      <Avatar
        resourceRn={connection.connectionRn}
        sx={sx}
        detail={{
          email: connection.email,
          firstName: connection.firstName,
          lastName: connection.lastName,
        }}
      />
    );
  }

  return (
    <StickyTooltip
      title={label}
    >
      <Box
        sx={{
          ...sx,
          borderRadius: '50%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: '#E2DEDA',
          color: 'text.secondary',
          fontWeight: 500,
        }}
      >
        {initial}
      </Box>
    </StickyTooltip>
  );
};

ConnectionBadge.propTypes = {
  connection: PropTypes.shape({
    connectionRn: PropTypes.string,
    displayName: PropTypes.string.isRequired,
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    email: PropTypes.string,
  }).isRequired,
  sx: PropTypes.object,
};

export default React.memo(ConnectionBadge);
